import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names, resolving Tailwind utility conflicts (the last conflicting
 * utility wins). Used by the shadcn-style UI primitives to compose a base class
 * set with caller-supplied overrides.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
